<!-- Loader -->
<div *ngIf="loader">
  <div id="global-loader">
    <img
      src="./assets/images/media/loader.svg"
      class="loader-img"
      alt="Loader"
    />
  </div>
</div>
<!-- /Loader -->
